/**
 * @module cercaliagl/layer/TrafficLive
 */
import Servers from '../servers';
import VTrafficPopup from '../view/VTrafficPopup';
import TrafficLiveJson from './styles/TrafficLive.json';
/**
 * @const
 * @type {string}
 */
var LayerId = 'TrafficLiveLayer';
/**
 * @const
 * @type {string}
 */
var SourceId = 'traffic';
/**
 * @const
 * @type {number}
 */
var REFRESH_INTERVAL = 60000;
var LAYERS_TO_LISTEN_CLICK = [
    'affectation_l_MaintenanceWorks',
    'affectation_l_NetworkManagement_bg',
    'affectation_l_NetworkManagement',
    'affectation_l_GeneralObstruction',
    'affectation_l_EnvironmentalObstruction',
    'affectation_l_Accident',
    'affectation_p_MaintenanceWorks',
    'affectation_p_GeneralObstruction',
    'affectation_p_EnvironmentalObstruction',
    'affectation_p_Accident',
];
/**
 * @classdesc
 */
var TrafficLive = /** @class */ (function () {
    /**
     * @constructor
     */
    function TrafficLive() {
        /**
         * @private
         * @type {string}
         */
        this.id_ = LayerId;
        /**
         * @private
         * @type {import("maplibre-gl").Map}
         */
        this.map_ = null;
        /**
         * @private
         * @type {boolean}
         */
        this.visible_ = true;
        /**
         * @private
         * @type {string}
         */
        this.beforeLayerId_ = 'poi-level-4';
        /**
         * @private
         * @type {import("maplibre-gl").Source}
         */
        this.source_ = {
            type: 'vector',
            tiles: ["".concat(Servers.hdflow, "?t=").concat(Date.now())],
        };
        this.hoveredFeature_ = null;
        /**
         * @private
         * @type {Array.<Object.<string, any>>}
         */
        this.layers_ = TrafficLiveJson.layers;
        /**
         * @private
         * @type {Function}
         */
        this.handleMouseOverFeature_ = this.handleMouseOverFeature_.bind(this);
        /**
         * @private
         * @type {Function}
         */
        this.handleMouseLeaveFeature_ = this.handleMouseLeaveFeature_.bind(this);
        /**
         * @private
         * @type {number|undefined}
         */
        this.refreshLayerIntervalId_ = null;
        /**
         * @private
         * @type {VTrafficPopup}
         */
        this.trafficPopup_ = new VTrafficPopup();
        /**
         * @private
        * @type {Object.<string, function>}
         */
        this.layerClickHandlers_ = {};
    }
    /**
     * @private
     */
    TrafficLive.prototype.addEventListeners_ = function () {
        var _this = this;
        if (!this.refreshLayerIntervalId_) {
            this.refreshLayerIntervalId_ = setInterval(this.refresh.bind(this), REFRESH_INTERVAL);
        }
        if (!this.layerClickHandlers_) {
            this.layerClickHandlers_ = {}; // Guardar las referencias de los handlers
        }
        LAYERS_TO_LISTEN_CLICK.forEach(function (layerId) {
            var handler = function (e) { return _this.handleLayerClick_(e); };
            _this.layerClickHandlers_[layerId] = handler;
            _this.map_.on('click', layerId, handler);
        });
    };
    /**
     * Force refresh layer.
     */
    TrafficLive.prototype.refresh = function () {
        this.source_.tiles = ["".concat(Servers.hdflow, "?t=").concat(Date.now())];
        this.map_.style.sourceCaches[SourceId].clearTiles();
        this.map_.style.sourceCaches[SourceId].update(this.map_.transform);
        this.map_.triggerRepaint();
    };
    /**
     * @private
     */
    TrafficLive.prototype.removeEventListeners_ = function () {
        if (this.refreshLayerIntervalId_) {
            clearInterval(this.refreshLayerIntervalId_);
            this.refreshLayerIntervalId_ = null;
        }
    };
    TrafficLive.prototype.removeClickEvents_ = function () {
        var _this = this;
        if (this.layerClickHandlers_) {
            LAYERS_TO_LISTEN_CLICK.forEach(function (layerId) {
                var handler = _this.layerClickHandlers_[layerId];
                if (handler) {
                    _this.map_.off('click', layerId, handler);
                }
            });
            this.layerClickHandlers_ = {};
        }
    };
    TrafficLive.prototype.cleanLayer = function () {
        this.removeClickEvents_();
        this.removeEventListeners_();
        this.closePopup();
    };
    /**
     * @private
     * @param {Event} e Event
     */
    TrafficLive.prototype.handleMouseOverFeature_ = function (e) {
        if (e.features && e.features.length > 0) {
            if (this.hoveredFeature_) {
                this.map_.setFeatureState({
                    id: this.hoveredFeature_.id,
                    source: SourceId,
                    sourceLayer: this.hoveredFeature_.layer['source-layer'],
                }, { hover: false });
            }
            this.hoveredFeature_ = e.features[0];
            this.map_.setFeatureState({
                id: this.hoveredFeature_.id,
                source: SourceId,
                sourceLayer: this.hoveredFeature_.layer['source-layer'],
            }, { hover: true });
        }
    };
    /**
     * @private
     */
    TrafficLive.prototype.handleMouseLeaveFeature_ = function () {
        if (this.hoveredFeature_) {
            this.map_.setFeatureState({
                id: this.hoveredFeature_.id,
                source: SourceId,
                sourceLayer: this.hoveredFeature_.layer['source-layer'],
            }, { hover: false });
        }
        this.hoveredFeature_ = null;
    };
    /**
     * @return {string} Id.
     */
    TrafficLive.prototype.getLayerId = function () {
        return this.id_;
    };
    /**
     * @param {import("../Map").default} map MAp
     */
    TrafficLive.prototype.setMap = function (map) {
        var _this = this;
        if (map) {
            this.map_ = map.getMapboxglMap();
            this.map_.addSource(SourceId, this.source_);
            var currentBeforeLayerId_1 = this.map_.getLayer(this.beforeLayerId_) ? this.beforeLayerId_ : null;
            if (!this.trafficPopup_.getElement().closest('body')) {
                var container = this.map_.getContainer();
                this.trafficPopup_.appendTo(container);
            }
            this.layers_.forEach(function (layer) {
                _this.map_.addLayer(layer, currentBeforeLayerId_1);
            });
            this.addEventListeners_();
        }
        else {
            this.layers_.forEach(function (layer) {
                _this.map_.removeLayer(layer.id);
            });
            this.map_.removeSource(SourceId);
            this.removeEventListeners_();
            this.closePopup();
        }
    };
    TrafficLive.prototype.handleLayerClick_ = function (e) {
        if (!e.features || e.features.length === 0) {
            return;
        }
        var properties = e.features[0].properties;
        this.trafficPopup_.update(properties);
        if (!this.trafficPopup_.isVisible()) {
            this.trafficPopup_.hide();
            this.trafficPopup_.show();
        }
    };
    /**
     * @param {boolean} visible Visible
     */
    TrafficLive.prototype.setVisible = function (visible) {
        this.visible_ = visible;
        this.map_.setLayoutProperty(this.id_, 'visibility', this.visible_ ? 'visible' : 'none');
    };
    /**
     * @return {Array.<Object.<string, any>>} Layers
     */
    TrafficLive.prototype.getLayers = function () {
        return this.layers_;
    };
    /**
     * Close
     */
    TrafficLive.prototype.closePopup = function () {
        this.trafficPopup_.hide();
    };
    return TrafficLive;
}());
export default TrafficLive;
//# sourceMappingURL=TrafficLive.js.map